import { Component, computed, contentChildren, effect, input } from '@angular/core';
import { BaseViewComponent, ButtonGroupSize, ButtonSize, Orientation } from '@sb/library/base';
import { ButtonComponent } from '../button.component';

@Component({
    selector: 'lib-button-group',
    templateUrl: './button-group.component.html',
    styleUrl: './button-group.component.scss'
})
export class ButtonGroupComponent extends BaseViewComponent {
    size = input<ButtonGroupSize>(ButtonGroupSize.Medium);
    stretch = input<boolean>(false);
    orientation = input<Orientation>(Orientation.Horizontal);

    buttons = contentChildren(ButtonComponent, { descendants: true });

    buttonGroupClass = computed(() => [
        this.size(),
        this.orientation() === Orientation.Vertical ? 'sb-button-group-vertical sb-button-group-stretch' : 'sb-button-group-horizontal',
        this.stretch() ? 'sb-button-group-stretch' : ''
    ]);

    constructor() {
        super();
        effect(() => {
            const buttonsList = this.buttons();
            const sizeValue = this.size();
            const stretchValue = this.stretch();
            
            for (const button of buttonsList) {
                if (sizeValue === ButtonGroupSize.Small) {
                    button.size = ButtonSize.Small;
                } else if (sizeValue === ButtonGroupSize.Large) {
                    button.size = ButtonSize.Large;
                } else if (sizeValue === ButtonGroupSize.XLarge) {
                    button.size = ButtonSize.XLarge;
                } else if (sizeValue === ButtonGroupSize.Medium) {
                    button.size = ButtonSize.Medium;
                }
                if (this.orientation() === Orientation.Vertical) {
                    button.stretch = true;
                } else {
                    button.stretch = stretchValue;
                }
            }
        });
    }
}
